/*

    Allows us to use filters as methods on the Vue component instance. For example:

    import mapFilters from '@/utils/map-filters';

    methods: {
        ...mapFilters(['titleCase']),

        foo() {
            console.log(this.titleCase('bar'));
        },
    }

 */
export default function mapFilters(filters) {
    return filters.reduce((result, filter) => {
        result[filter] = function mapFilter(...args) {
            return this.$options.filters[filter](...args);
        };

        return result;
    }, {});
}
